
// slider.tsx
import { useFieldFormContext } from "@/features/question/components/organisms/FieldForm";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";

export function SliderForm() {
    const { isFormDisabled, form } = useFieldFormContext();

    return (
        <div className="flex flex-col gap-2">
            <FormField
                name="field_min"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Minimum number</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_max"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Maximum number</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_default_value"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Default value</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_step"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Number to increment by</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='number'
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_min_label"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Label for minimum value</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='text'
                                maxLength={60}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_label"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Label for middle value</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='text'
                                maxLength={60}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
            <FormField
                name="field_max_label"
                control={form.control}
                render={({ field }) => (
                    <FormItem>
                        <FormLabel className="text-sm font-medium">Label for maximum value</FormLabel>
                        <FormControl>
                            <Input
                                {...field}
                                disabled={isFormDisabled}
                                type='text'
                                maxLength={60}
                                autoComplete="off"
                            />
                        </FormControl>
                        <FormMessage />
                    </FormItem>
                )}
            />
        </div>
    );
}
